import qs from 'qs';

const CaptureAdvId = () => {
  let ary = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  if (ary['adv_id']) {
    localStorage.setItem('adv_id', ary['adv_id']);
  }
  return null;
};
export default CaptureAdvId;



// WEBPACK FOOTER //
// ./src/components/CaptureAdvId.js